import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchVehicleRegisterVehiclesRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  /**
   * Vehicle registration plate or null.
   */
  @observable
  licensePlate?: string;

  /**
   * Country ID.
   */
  @observable
  countryId?: string;

  /**
   * Official record ID or null.
   * @example
   * ABC-23456/2022
   */
  @observable
  officialRecordId?: string;

  /**
   * Charge order ID.
   */
  @observable
  chargeOrderId?: string;

  /**
   * Order identifier (variable symbol) or null.
   */
  @observable
  orderIdent?: number;

  /**
   * Charge ID.
   */
  @observable
  chargeId?: string;
}

export const SearchVehicleRegisterVehiclesRequestValidationRules: EntityValidationRules<SearchVehicleRegisterVehiclesRequest> = {
  licensePlate: {
    required: true,
    isLicensePlate: {
      required: false,
    },
  },
};
